import {Button} from "@/components/ui/button";
import {ArrowTurnDownRightIcon} from "@heroicons/react/16/solid";

interface Props {
    onSelect: (question: string) => void;
    list?: string[];
}

const exampleList = [
    "什么是安盛保险？",
    "安盛保险的产品有哪些？",
    "安盛保险的理赔流程是怎样的？",
    "我想了解友邦保险的产品，你能推荐一些吗？",
];

export default function ExampleQuestions({onSelect, list = exampleList}: Props) {
    return (
        <div className="flex flex-col gap-2 mt-6">
            {list.map((text, i) => (
                <div>
                    <div
                        key={i}
                        className="example rounded-full text-sm px-4 py-2 cursor-pointer inline-block bg-[var(--widget-btn_click_4)]"
                        onClick={() => onSelect(text)}
                    >
                        <ArrowTurnDownRightIcon className="inline-block text-xs h-3"></ArrowTurnDownRightIcon> {text}
                    </div>
                </div>
            ))}
        </div>
    );
}
